import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    fetchUser,
    fetchUserPermissions,
    fetchStagesList,
    toggleHelp,
    logout
} from "actions";
import { AuthConnect } from "hocs";
import { Table } from "components";
import {
    Layout,
    Modal,
    message,
    Drawer,
    Card,
    Alert,
    Spin,
} from "antd";
import { List,
    Map
} from "immutable";
import { LoaderSkeleton } from "components";
import QuickSearch from "components/quick-search";
import {
    HeaderMenu
} from "templates";
import {
    HEADER_MENU_ITEMS,
    STATE_STATUS
} from "constants";
import PROGCAP_ICON from "assets/progcapLogo.png";
import ResetPasswordForm from "forms/reset-password-form";
import { AuthService } from "services";
import { CASE_SEARCH_CONST_COLS } from "constants/table-columns";
import { CASE_ACTIVE_STATUS } from "constants/enums";

import "styles/base.css";
import "styles/header.css";
import "antd/dist/antd.css";

import { PermissionContextProvider } from "hocs";

const Header = Layout.Header;
const Content = Layout.Content;

// const PSKIT_COLS = new OrderedMap({
//     pod_no: {
//         title: "POD No",
//         key: "pod_no",
//         dataIndex: "pod_no",
//         align: "center",
//     },
//     date: {
//         title: "Date",
//         key: "date",
//         dataIndex: "date",
//         align: "center",
//     },
//     courier_company: {
//         title: "Courier Company",
//         key: "courier_company",
//         dataIndex: "courier_company",
//         align: "center",
//     }
// });

class App extends React.Component {
    state = {
        isVisibleModal: false,
        isDrawerOpen: false,
        drawerData: null,
        toggleHelp: this.props.toggleHelpVal || false,
        rejectedRemarks: null,
        holdRemarks: null,
        isInsideCompany: false
    };

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.isAuthenticated &&
            nextProps.user.get("status") === STATE_STATUS.UNFETCHED
        ) {
            nextProps.fetchUser();
        }
        if (
            nextProps.isAuthenticated &&
            nextProps.user.get("permissionsStatus") ===
                STATE_STATUS.UNFETCHED &&
            nextProps.user.get("status") === STATE_STATUS.FETCHED
        ) {
            nextProps.fetchUserPermissions();
        }
        if(
            !this.state.isInsideCompany &&
            nextProps.isDistributorRM
            // &&
            // nextProps.user.get("status") === STATE_STATUS.FETCHED &&
            // nextProps.stages.get("status") === STATE_STATUS.FETCHED
        ) {
            this.setState({
                isInsideCompany: true
            }, () => {
                this.props.history.replace("/app/companies");
            });
        }
        if (
            nextProps.isAuthenticated &&
            nextProps.user.get("status") === STATE_STATUS.FETCHED &&
            nextProps.stages.get("status") === STATE_STATUS.UNFETCHED
        ) {
            nextProps.fetchStagesList(nextProps.user.get("data").groups);
        }
        if(
            this.props.history &&
            this.props.history.location &&
            this.props.history.location.state &&
            this.props.history.location.state.closeSearchDrawer &&
            this.state.isDrawerOpen
        ) {
            this.setState({
                isDrawerOpen: false,
                drawerData: null
            });
        }
    }

    // isRedirected = false;

    componentDidUpdate() {
        // const { history, isAuthenticated, user, stages } = this.props;
        // if(
        //     isAuthenticated && 
        //     !this.isRedirected &&
        //     user.get("status") === STATE_STATUS.FETCHED &&
        //     stages.get("status") === STATE_STATUS.FETCHED &&
        //     user.get("permissionsStatus") === STATE_STATUS.FETCHED
        // ) {
        //     this.isRedirected = true;
        //     history.replace(history.location);
        // }
    }

    isLoading() {
        const { user, stages, isAuthenticated } = this.props;
        return (
            !isAuthenticated ||
            user.get("status") === STATE_STATUS.UNFETCHED ||
            stages.get("status") === STATE_STATUS.UNFETCHED ||
            user.get("permissionsStatus") === STATE_STATUS.UNFETCHED
        );
    }

    openResetPasswordModal = () => {
        this.setState({
            isVisibleModal: true
        });
    };

    submitValues = values => {
        AuthService.resetPassword(
            values.currentPassword,
            values.newPassword,
            values.confirmPassword
        ).then(({ data }) => {
            if (data) {
                message.success("Password Changed Successfully");
                this.setState({
                    isVisibleModal: false
                });
            } else {
                message.error("Invalid Credentials");
            }
        });
    };

    openDrawer = record => {
        let data = [record];
        let rejectedRemarks, holdRemarks;
        let case_status = CASE_ACTIVE_STATUS.findKey(_ => record.case_status === _);
        if(
            record &&
            record.current_case_task &&
            record.current_case_task.length
        ) {
            data = record.current_case_task.map(_ => {
                return {
                    ...record,
                    case_status,
                    current_case_task: [_]
                };
            });
        } else {
            data = [{...record, case_status}];
        }

        if (
            case_status === "Reject"
        ) {
            rejectedRemarks = !record.rejection_remarks || record.rejection_remarks === "" || record.rejection_remarks === " " ? "N/A" : record.rejection_remarks;
            holdRemarks = null;
        }

        if (
            case_status === "Hold"
        ) {
            holdRemarks = !record.hold_remarks || record.hold_remarks === "" || record.hold_remarks === " " ? "N/A" : record.hold_remarks;
            rejectedRemarks = null;
        }
        this.setState({
            isDrawerOpen: true,
            drawerData: data,
            rejectedRemarks,
            holdRemarks
        });
    };

    onToggleHelp = () => {
        this.setState(
            {
                toggleHelp: !this.state.toggleHelp
            },
            () => {
                this.props.toggleHelp(this.state.toggleHelp);
            }
        );
    };

    getName = () => {
        const firstName = this.props.user && this.props.user.getIn(["data", "first_name"]);
        const lastName = this.props.user && this.props.user.getIn(["data", "last_name"]);
        if(lastName) {
            return firstName + " " + lastName;
        }
        return firstName;
    }

    checkIfUserIsDistributorRM = () => {
        if(
            this.props.user.get("status") === STATE_STATUS.UNFETCHED ||
            this.props.user.get("status") === STATE_STATUS.FETCHING
        ) {
            return false;
        }
        // if(this.props.isDistributorRM) {
        //     return false;
        // }
        return true;
    }

    get headerMenuItems(){
        let menuItem = HEADER_MENU_ITEMS;
        if (!this.props.permissions.get("page_dbt_bulk_assign") && !this.props.permissions.get("page_dbt_edit")){
            let data = menuItem.getIn(["actions", "children"]).delete("payment_program");
            menuItem = menuItem.setIn(["actions", "children"], data);
        }
        if (!this.props.permissions.get("page_db_onboarding_bulk_assign") && !this.props.permissions.get("page_dbonboarding_edit")){
            let data = menuItem.getIn(["actions", "children"]).delete("db_onboarding").delete('anchor_onboarding');
            menuItem = menuItem.setIn(["actions", "children"], data);
        }
        
        if (!(this.props.permissions.get("page_adhoc_edit")  || this.props.permissions.get("page_adhoc_bulk_assign"))){
            let data = menuItem.getIn(["actions", "children"]).delete("adhoc");
            menuItem = menuItem.setIn(["actions", "children"], data);
        }
        if (!(this.props.permissions.get("can_mpa_approve"))){
            let data = menuItem.getIn(["actions", "children"]).delete("mpa_approval");
            menuItem = menuItem.setIn(["actions", "children"], data);
        }
        return menuItem;
    }

    render() {
        const {
            location,
            match,
            history,
            user
        } = this.props;
        if (user.get("permissions") && !user.get("permissions").size) {
            return <Layout className={"vh-100 justify-content-center"}><Spin loading={user.get("permissions") && !user.get("permissions")}></Spin></Layout>
        }
        return (
            <PermissionContextProvider value={user.get("permissions")}>
                {/* <IdleTimer
                        ref={ref => this.idleTimer = ref}
                        timeout={1000 * 60 * 5}
                        onActive={this.handleOnActive}
                        onIdle={this.handleOnIdle}
                        onAction={this.handleOnAction}
                        debounce={250}
                    /> */}
                <Layout className={"vh-100"}>
                    <Header
                        className={
                            "p-0 d-flex align-items-center justify-content-space-between header-height"
                        }
                    >
                        <Card
                            className={"padless-card"}
                            header={"false"}
                            style={{
                                marginLeft: "10px",
                                border: "0px",
                                background: "white"
                            }}
                        >
                            <div
                                style={{
                                    lineHeight: "45px"
                                }}
                                className="px-5"
                            >
                                <img
                                    src={PROGCAP_ICON}
                                    alt="PROGCAP"
                                    width={100}
                                    className={"cursor-pointer"}
                                    onClick={() => {
                                        if (this.props.isDistributorRM) {
                                            this.props.history.replace("/app/companies");
                                        } else {
                                            this.props.history.push("/app/inbox");
                                        }
                                    }}
                                />
                            </div>
                        </Card>

                        {/* <Switch
                                defaultChecked={this.state.toggleHelp}
                                onChange={this.onToggleHelp}
                            />
                            {"Help"} */}
                        {this.checkIfUserIsDistributorRM() ? <QuickSearch
                            history={history}
                            location={location}
                            openDrawer={this.openDrawer}
                        /> : null}
                        <div
                            className={
                                "d-flex justify-content-end align-items-center"
                            }
                        >

                            <HeaderMenu
                                location={location}
                                onToggleHelp={this.onToggleHelp}
                                match={match}
                                userName={this.getName()}
                                isDistributorRM={this.props.isDistributorRM}
                                permissions={this.props.user && this.props.user.get("permissions")}
                                history={history}
                                menuItems={this.headerMenuItems}
                                openResetPasswordModal={
                                    this.openResetPasswordModal
                                }
                                logout={this.props.logout}
                            />

                            {this.props.user &&
                                this.props.user.get("data") &&
                                this.props.user.get("data", {}).profile_icon ? (
                                <img
                                    src={
                                        this.props.user.get("data").profile_icon
                                    }
                                    alt="BANK"
                                    width={150}
                                    style={{
                                        marginRight: "10px"
                                    }}
                                    className={"cursor-pointer"}
                                />
                            ) : null}
                        </div>
                    </Header>
                    <Layout className={"base-layout"}>
                        <LoaderSkeleton loading={this.isLoading()}>
                            <Content className={"h-100 base-content"}>
                                {this.props.children}
                            </Content>
                        </LoaderSkeleton>
                    </Layout>
                </Layout>
                <Modal
                    title={"Reset Password"}
                    visible={this.state.isVisibleModal}
                    footer={null}
                    onCancel={() => {
                        this.setState({
                            isVisibleModal: false
                        });
                    }}
                    closable={true}
                    destroyOnClose={true}
                >
                    <ResetPasswordForm submitValues={this.submitValues} />
                </Modal>
                <Drawer
                    visible={this.state.isDrawerOpen}
                    closable={true}
                    destroyOnClose={true}
                    onClose={() => {
                        this.setState({
                            isDrawerOpen: false,
                            drawerData: null
                        });
                    }}
                    placement={"right"}
                    width={"60vw"}
                >
                    {this.state.rejectedRemarks ? (
                        <Alert
                            message="Rejection Remarks"
                            description={this.state.rejectedRemarks}
                            type="error"
                        />
                    ) : null}
                    {this.state.holdRemarks ? (
                        <Alert
                            message="Hold Remarks"
                            description={this.state.holdRemarks}
                            type="error"
                        />
                    ) : null}
                    <Table
                        columns={CASE_SEARCH_CONST_COLS}
                        showTopSection={false}
                        noRowSelection={true}
                        data={
                            this.state.drawerData
                                ? new List(this.state.drawerData)
                                : new List([])
                        }
                        size={"small"}
                    />
                    <Card
                        className={"padless-card"}
                        title={"Address"}
                    >
                        <div className={"px-10 py-32"}>
                            {
                                this.state.drawerData &&
                                this.state.drawerData[0] &&
                                (this.state.drawerData[0].address_line_1 || "") +
                                " " +
                                (this.state.drawerData[0].address_line_2 || "") +
                                ", " +
                                (this.state.drawerData[0].city || "") +
                                ", " +
                                (this.state.drawerData[0].state || "") +
                                ", " +
                                (this.state.drawerData[0].pincode || "")
                            }
                        </div>
                    </Card>
                    {/* <Card
                            className={"padless-card"}
                            title={"PSKit Courier Details"}
                        >
                            <Table
                                columns={PSKIT_COLS}
                                showTopSection={false}
                                noRowSelection={true}
                                pagination={false}
                                bordered={true}
                                showFooter={false}
                                data={new List([])}
                                type={"inner"}
                                className={"padless-table"}
                            />
                        </Card> */}
                </Drawer>
            </PermissionContextProvider>
        );
    }
}

App.propTypes = {
    // Routing State
    location: PropTypes.object,
    match: PropTypes.object,
    history: PropTypes.object,
    //Authentication State
    isAuthenticated: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    //Data Actions
    fetchUser: PropTypes.func,
    fetchUserPermissions: PropTypes.func,
    fetchStagesList: PropTypes.func,
    //Data
    user: PropTypes.object,
    stages: PropTypes.object,
    logout: PropTypes.func,
    toggleHelp: PropTypes.func,
    toggleHelpVal: PropTypes.bool,
    isDistributorRM: PropTypes.bool,
    permissions : PropTypes.object
};

const mapStateToProps = state => {
    return {
        user: state.user,
        stages: state.stages,
        toggleHelpVal: state.toggleHelp.get("value"),
        isDistributorRM: !!((state.user.getIn(["data", "groups"]) || Map({})).find(_ => _.id === 41)),
        permissions: state.user.get("permissions"),
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchUser,
            fetchUserPermissions,
            fetchStagesList,
            toggleHelp,
            logout
        },
        dispatch
    );

const ReduxConnectedApp = connect(
    mapStateToProps,
    mapDispatchToProps
)(App);

export default AuthConnect(ReduxConnectedApp);
